import React, { SVGProps } from 'react';

export type SvgContainerProps = SVGProps<SVGSVGElement>;
export type VariantSvgContainerProps = SvgContainerProps & { filled?: true };

export const SvgContainer = (props: SvgContainerProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
    width={24}
    height={24}
    {...props}
  />
);
